module.exports = __webpack_public_path__ + "img/left_right_layout_3.92e86bca.svg";